import {React, useEffect, useState} from 'react'
import QmModuleStyle from '../styles/qm.module.css';
import { make_utilize } from '../services/api';
import { errorMsg } from '../../../helper/helpers';
import Button from '../../common/Button';
import animation_1 from '../assets/animation_1.png';
import animation_2 from '../assets/animation_2.png';
import restaurant_img from '../assets/restaurant_img.jpg';

const AvailableInvestments = ({simObj,setSimObj,formatNum,setError,toggleSimulation,setToggleSimulation,isRequestLoading,setIsShowPlaceOrder,setIsRequestLoading}) => {
    const [availableInvestment, setAvailableInvestment] = useState({});
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    let intervalId;
    const QMInvestmentOptionsLen = simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.length;
   // const [oids,setOids] = useState([]);
    // const images = [animation_1, animation_2];
    const images = [restaurant_img, restaurant_img] 
    const makeUtilize = () =>{
       // document.querySelector("#placeOrderButton").setAttribute("disabled", "disabled");
        //document.querySelector("#utilizeButton").setAttribute("disabled", "disabled");
       // console.log(simObj)
        const mUtilizeObj = {
          "exinstanceid": simObj.executioninstanceid,
          "id": simObj.id,
          "currentstep": simObj.currentstep,
          "investmentOptions": simObj.laststate?.investmentOptions
        }
        if(!isRequestLoading){
            document.querySelector("#playSumButton").setAttribute("disabled","true");
            setIsRequestLoading(true);
            make_utilize(mUtilizeObj, simObj.sessionid).then(function (response) {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                setError(response?.data)
            }
            else{
            setSimObj(response.data);
            setIsShowPlaceOrder(true);
            setIsRequestLoading(false);
            document.querySelector("#playSumButton").removeAttribute("disabled");
            document.querySelector("#playSumButton").focus();
            let btnText = document.querySelector("#playSumButton").innerText;
            document.querySelector("#playSumButton").setAttribute("aria-label", btnText)
            if(response.data.version > 1){
                setAvailableInvestment({"availableCash": (simObj?.laststate?.availableCashForImprovement) ? (Math.round(simObj?.laststate?.availableCashForImprovement)) : 0,"tcosInvestments": 0,"isEnoughCash": (simObj?.laststate?.availableCashForImprovement) ? true : false});
            }
            else{
                setAvailableInvestment({"availableCash": (simObj?.laststate?.availableCash) ? (Math.round(simObj?.laststate?.availableCash)) : 0,"tcosInvestments": 0,"isEnoughCash": (simObj?.laststate?.availableCash) ? true : false});
            }
            if(response.data?.laststate?.investmentOptions?.QMInvestmentOptions?.length == 0){
                document.querySelector("#playSumButton").click();
                makeAnimation();
            }else{
                pauseAnimation();
            }
            }
            }).catch((error) => {
            //setError(errorMsg);
            setError({"id":"00000","msg":errorMsg})
            console.log(error);
            })
        }
      //  document.querySelector("#playSumButton").focus();
    }
    const isOrderAllReadyPlaced = () =>{
        return simObj?.laststate?.investmentOptions?.id > 0 ? false : true;
    }
    const pauseAnimation = () =>{
        clearInterval(intervalId);
    }
    const makeAnimation = () =>{
         intervalId = setInterval(() => {
            const nextImageIndex = (currentImageIndex + 1) % images.length;
            setCurrentImageIndex(nextImageIndex);
        }, 30000); // 60 seconds in milliseconds 
    }
    const updateAvailableInvestment = (element) =>{
        const value = Number(element.value);
        // if((simObj?.version == 1) || (simObj?.version > 1 && simObj?.level == 'EASY')){
            (element.checked) ? setAvailableInvestment({"availableCash": availableInvestment.availableCash - value,"tcosInvestments": availableInvestment.tcosInvestments + value,"isEnoughCash": (availableInvestment.availableCash - value) > 0}) : setAvailableInvestment({"availableCash": availableInvestment.availableCash + value,"tcosInvestments": availableInvestment.tcosInvestments - value,"isEnoughCash": (availableInvestment.availableCash + value) > 0});
        // }
        //(element.checked) ? setOids([...oids, element.getAttribute("oid")]) : setOids(oids.filter((item)=> item != element.getAttribute("oid")));
            setSimObj((simObj) => ({
                ...simObj,
                laststate:{
                    ...simObj.laststate,
                    investmentOptions: {
                        ...simObj.laststate.investmentOptions,
                        QMInvestmentOptions: simObj.laststate.investmentOptions.QMInvestmentOptions.map(option => {
                            return (option.oid === element.getAttribute("oid") && (element.checked)) ? ({ ...option, selected: 1 }) : (option.oid === element.getAttribute("oid") && (!element.checked)) ? ({ ...option, selected: 0 })  : option;
                        })
                    }
                },                
              }));
    }
    const isReadOnly = ((simObj.status != 'COMPLETED') && (!toggleSimulation && !isRequestLoading)) ? false : true;//&& (simObj.laststate?.quantityordered == 0)
    useEffect(() => {
        (QMInvestmentOptionsLen == 0) && makeAnimation();  
        return () => {
            clearInterval(intervalId);
        };
    }, [currentImageIndex]);
    useEffect(()=>{
        (QMInvestmentOptionsLen > 0) && pauseAnimation();
    },[QMInvestmentOptionsLen > 0])
    useEffect(()=>{
        if(simObj?.version > 1){
            setAvailableInvestment({"availableCash": (simObj?.laststate?.availableCashForImprovement) ? (Math.round(simObj?.laststate?.availableCashForImprovement)) : 0,"tcosInvestments": 0,"isEnoughCash": (simObj?.laststate?.availableCashForImprovement) ? true : false});
        }
        else{
            setAvailableInvestment({"availableCash": (simObj?.laststate?.availableCash) ? (Math.round(simObj?.laststate?.availableCash)) : 0,"tcosInvestments": 0,"isEnoughCash": (simObj?.laststate?.availableCash) ? true : false});
        }
        (QMInvestmentOptionsLen > 0 && simObj?.laststate?.investmentOptions?.isUpcomming) && setToggleSimulation(false);
    },[simObj?.laststate?.availableCash,simObj?.laststate?.availableCashForImprovement,simObj?.currentstep])

    return (
        <div className={`${QmModuleStyle["available-investments"]}`}>
            {
                QMInvestmentOptionsLen > 0 ?
                    (<>
                        <div className={`${QmModuleStyle['decisions-table']}`}>
                            <div>
                                <div style={(simObj?.version > 1 && (simObj?.laststate?.level == 'MEDIUM' || simObj?.laststate?.level == 'HARD'))?{width:"100%",borderRight:"none",paddingRight:0}:{}}>
                                    <span>Available Cash for Improvements</span>
                                    <span><strong>${`${((simObj?.version == 1) || (simObj?.version > 1 && simObj?.laststate?.level == 'EASY')) ? formatNum(availableInvestment.availableCash): formatNum(simObj?.laststate?.availableCashForImprovement)}`}</strong></span>
                                </div>
                                {
                                    (!(simObj?.version > 1) || (simObj?.version > 1 && simObj?.laststate?.level == 'EASY'))
                                    ? <div id='selectedInvestmentCost'>
                                        <span>Total Cost of Selected Investments</span>
                                        <span><strong>${formatNum(availableInvestment.tcosInvestments)}</strong></span>
                                    </div>
                                    : ''
                                }
                                
                            </div>
                            <div className={`${QmModuleStyle['decision-table-parent']}`}>
                                <table className="ui celled table unstackable">
                                    <tbody>
                                        {
                                            simObj?.laststate?.investmentOptions?.QMInvestmentOptions?.map((item, index) => {
                                                return <tr  key={`${index}_11`}>
                                                    <td>
                                                        <label htmlFor={`check${index}`} aria-checked={item.selected ? true : false}>
                                                            <input id={`check${index}`} disabled={isOrderAllReadyPlaced() || isReadOnly} checked={item.selected} value={item?.cost} oid={item?.oid} type="checkbox" onChange={(e)=>{updateAvailableInvestment(e.target)}} />
                                                            {item?.option}
                                                        </label>
                                                    </td>
                                                    <td style={(simObj?.optionsToHide?.indexOf(item.oid.split("_")[0]) == -1) ? {} :{fontSize:"13px"}}>{`${(simObj?.optionsToHide?.indexOf(item.oid.split("_")[0]) == -1) ? "$"+formatNum(item?.cost) : "Unknown"}`}</td>
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>


                        </div>
                        <div className={`${QmModuleStyle['avail-invest-list-controls']}`}>
                            <div>                                
                                {
                                    !availableInvestment.isEnoughCash && (<span className={`${QmModuleStyle['not-enough-cash']}`}>There is not enough cash balance to take the selected investment decision(s).</span>)
                                }                                
                            </div>
                            <div>
                                {/* <Button btnName="Skip" btnWidth={70} customBtnStyle={{ background: "transparent", color: "#B2347B", border: "1px solid #B2347B" }} /> */}
                                <Button btnName="Utilize" id="utilizeButton" btnWidth={80} disabled={(availableInvestment.isEnoughCash && availableInvestment.tcosInvestments > 0 && !isReadOnly) ? false : true} clickEventHandler={makeUtilize} />
                            </div>
                        </div>
                    </>)
                    :
                    (<div className={`${QmModuleStyle['utilized-invest']}`}>
                        <div className={`${QmModuleStyle['_content']}`}>
                            <p>All decisions have been made.</p>
                            <p>New decisions to be made will show up here. Click on the Utilized Investments to view your past decisions.</p>
                        </div>
                        <div className={`${QmModuleStyle['_image']}`}>
                            <img src={images[currentImageIndex]} alt="" />
                        </div>
                    </div>)
            }
        </div>

    )
}

export default AvailableInvestments
